import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app/app.component';
import { IframeViewComponent } from './components/iframe-view/iframe-view.component';
import { MarkdownViewComponent } from './components/markdown-view/markdown-view.component';

@NgModule({
  declarations: [AppComponent, IframeViewComponent, MarkdownViewComponent],
  imports: [
    CommonModule
  ]
})
export class ViewerModule {
}
